import { defineStore } from 'pinia'
import { httpClient } from '../shared/services/http-client'
// import { useUserStore } from './user'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: '',
    username: '',
    _isAuthenticated: false, //ideally set to false and then used to check if user is authenticated
  }),
  getters: {
    getToken(): string {
      return this.token
    },
    getUsername(): string {
      return this.username
    },
    isAuthenticated(): boolean {
      return this._isAuthenticated
    },
    retrieveUserDataFromSession(): any {
      this.token = sessionStorage.getItem('token') || ''
      this.username = sessionStorage.getItem('username') || ''
    },

    // Add other necessary getters here
  },
  actions: {
    setToken(token: string): void {
      this.token = token
    },
    setUsername(username: string): void {
      this.username = username
    },
    setAuthenticated(isAuthenticated: boolean): void {
      this._isAuthenticated = isAuthenticated
    },
    setUserDataToSession(token: string, username: string): void {
      sessionStorage.setItem('token', token)
      sessionStorage.setItem('username', username)
    },
    async retrieveUserDataFromApi(token: string): Promise<any> {
      // make an API call to retrieve user data
      // and set the token and username
      console.log(token)
      const result = await httpClient.get('/users')
      if (result) {
        // this.saveUserDataToState(result)
        this.saveUserDataToSession(result)
      } else {
        console.log(
          'Error message retrieving user data and redirec to login state or landing page without any further sidebar menu items shown',
        )
      }
    },
    // saveUserDataToState(result: any): any {
    //   this.selectedEntity = result.selectedEntity;
    //   const userStore = useUserStore()
    //   userStore.setUserData(result.data)
    // },
    saveUserDataToSession(result: any): any {
      sessionStorage.setItem('userData', JSON.stringify(result.data))
    },
    // Add other necessary actions here
  },
})
